// Copyright © 2026 Alex Bruce. All rights reserved.
// Proprietary and confidential. Unauthorized copying, modification,
// or distribution is strictly prohibited.

// Shared empty state — icon + headline + one sentence + optional CTA.
// Every tab with no data should render this instead of a blank panel,
// so a new user always knows what to do next.

import React from "react";
import type { Theme } from "../lib/theme";
import Button from "./Button";

export default function EmptyState({
  T,
  icon,
  headline,
  body,
  ctaLabel,
  onCta,
  compact = false,
}: {
  T: Theme;
  icon?: React.ReactNode;
  headline: string;
  body?: string;
  ctaLabel?: string;
  onCta?: () => void;
  compact?: boolean;
}) {
  return (
    <div
      style={{
        textAlign: "center",
        padding: compact ? "28px 20px" : "48px 24px",
        color: T.textWeak,
      }}
    >
      {icon && (
        <div style={{ fontSize: 32, marginBottom: 12, opacity: 0.7, display: "flex", justifyContent: "center" }}>
          {icon}
        </div>
      )}
      <div style={{ fontSize: 14, fontWeight: 600, color: T.textMuted, marginBottom: 6 }}>
        {headline}
      </div>
      {body && (
        <div style={{ fontSize: 12, maxWidth: 420, margin: "0 auto", lineHeight: 1.55 }}>
          {body}
        </div>
      )}
      {ctaLabel && onCta && (
        <div style={{ marginTop: 16, display: "flex", justifyContent: "center" }}>
          <Button T={T} variant="primary" size="md" onClick={onCta}>
            {ctaLabel}
          </Button>
        </div>
      )}
    </div>
  );
}
